import { useFeatureFlag } from '@/shared/core/hooks/use-feature-flag/use-feature-flag.ts'
import { NavBar } from '@/teams/portfolio/components/nav-bar/nav-bar.tsx'
import { ContactSection } from '@/teams/portfolio/components/section/contact-section/contact-section.tsx'
import { ExperienceSection } from '@/teams/portfolio/components/section/experience-section/experience-section.tsx'
import { HomeSection } from '@/teams/portfolio/components/section/home-section/home-section.tsx'
import { ProjectsSection } from '@/teams/portfolio/components/section/projects-section/projects-section.tsx'
import { SkillsSection } from '@/teams/portfolio/components/section/skills-section/skills-section.tsx'
import { useScrollToSection } from '@/teams/portfolio/hooks/use-scroll-to-section/use-scroll-to-section.ts'
import type { SectionId } from '@/teams/portfolio/types/section-id.ts'

interface HomePageProps {
	activeSection: SectionId
}

export function HomePage({ activeSection }: Readonly<HomePageProps>) {
	useScrollToSection(activeSection)

	const sectionSkills = useFeatureFlag('portfolio.section.skills.enabled')
	const sectionProjects = useFeatureFlag('portfolio.section.projects.enabled')
	const sectionExperience = useFeatureFlag(
		'portfolio.section.experience.enabled',
	)
	const sectionContact = useFeatureFlag('portfolio.section.contact.enabled')

	return (
		<div data-testid={'home-page'}>
			<NavBar activeSection={activeSection} />
			<HomeSection />
			{sectionSkills && <SkillsSection />}
			{sectionExperience && <ExperienceSection />}
			{sectionProjects && <ProjectsSection />}
			{sectionContact && <ContactSection />}
		</div>
	)
}
